import { MenuDivider as ChakraMenuDivider } from '@chakra-ui/react'
import { ReactElement } from 'react'

import { MenuDividerProps } from './MenuDivider.types'

export default function Menu(props: MenuDividerProps): ReactElement {
  return <ChakraMenuDivider {...props} translate="no" />
}
